if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this._scheduleTimeout = null;
      this._blockTimeouts = [];
    }

    connectedCallback() {
      this.section = this.closest('[data-section-type="announcement"]');
      this.refreshPromoDates();
      this.initSchedule();
      this.initCountdowns();

      const enableSlider = this.dataset.enableSlider === "true";
      if (enableSlider) {
        this.initSlider();
      }
    }

    disconnectedCallback() {
      if (this._scheduleTimeout) clearTimeout(this._scheduleTimeout);
      this._blockTimeouts.forEach(clearTimeout);
    }

    parseDate(dateStr) {
      if (!dateStr) return null;
      const ms = Date.parse(dateStr.trim().split(" ").join("T"));
      return Number.isNaN(ms) ? null : ms;
    }

    formatMonthEndLabel(date = new Date()) {
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
      const day = String(lastDay).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      return `${day}/${month}`;
    }

    refreshPromoDates() {
      const label = this.formatMonthEndLabel();
      this.querySelectorAll("[data-month-end-label]").forEach((node) => {
        node.textContent = `\u00A0${label}`;
      });
    }

    getMonthWindow(startDay = 25) {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const start = new Date(year, month, startDay, 0, 0, 0, 0).getTime();
      const end = new Date(year, month + 1, 0, 23, 59, 59, 999).getTime();
      return { start, end };
    }

    hideBar() {
      if (!this.section) return;
      this.section.remove();
      document.documentElement.style.setProperty("--m-announcement-height", "0px");
      if (window.MinimogSettings) {
        window.MinimogSettings.topbarHeight = 0;
      }
    }

    removeItem(item) {
      if (!item) return;
      item.remove();
      if (this.slider && typeof this.slider.update === "function") {
        this.slider.update();
      }
      if (!this.querySelector(".m-announcement-bar__item")) {
        this.hideBar();
      }
    }

    scheduleItemHide(item, endMs) {
      const now = Date.now();
      if (!endMs || endMs <= now) {
        this.removeItem(item);
        return;
      }
      const timeout = setTimeout(() => this.removeItem(item), endMs - now);
      this._blockTimeouts.push(timeout);
    }

    initSchedule() {
      if (!this.section) return;

      const now = Date.now();
      const sectionStart = this.parseDate(this.section.dataset.scheduleStart);
      const sectionEnd = this.parseDate(this.section.dataset.scheduleEnd);

      if (sectionStart && now < sectionStart) {
        this.hideBar();
        return;
      }

      if (sectionEnd && now >= sectionEnd) {
        this.hideBar();
        return;
      }

      this.querySelectorAll(".m-announcement-bar__item").forEach((item) => {
        const mode = item.dataset.scheduleMode;

        if (mode === "monthly_end") {
          const startDay = parseInt(item.dataset.monthlyStartDay || "25", 10);
          const window = this.getMonthWindow(startDay);

          if (now < window.start || now >= window.end) {
            this.removeItem(item);
            return;
          }

          this.scheduleItemHide(item, window.end);
          return;
        }

        const start = this.parseDate(item.dataset.scheduleStart);
        const end = this.parseDate(item.dataset.scheduleEnd);

        if (start && now < start) {
          this.removeItem(item);
          return;
        }

        if (end && now >= end) {
          this.removeItem(item);
          return;
        }

        if (end && end > now) {
          this.scheduleItemHide(item, end);
        }
      });

      if (!this.querySelector(".m-announcement-bar__item")) {
        this.hideBar();
        return;
      }

      if (sectionEnd && sectionEnd > now) {
        this._scheduleTimeout = setTimeout(() => this.hideBar(), sectionEnd - now);
      }
    }

    initCountdowns() {
      if (typeof CountdownTimer === "undefined") return;

      this.querySelectorAll("[data-time]").forEach((el) => {
        let endTime = this.parseDate(el.dataset.time);
        const item = el.closest(".m-announcement-bar__item");

        if (item && item.dataset.scheduleMode === "monthly_end") {
          const startDay = parseInt(item.dataset.monthlyStartDay || "25", 10);
          endTime = this.getMonthWindow(startDay).end;
        }

        if (!endTime) return;

        if (endTime <= Date.now()) {
          this.onCountdownEnd(el);
          return;
        }

        new CountdownTimer(el, Date.now(), endTime, {
          callback: () => this.onCountdownEnd(el),
        });
      });
    }

    onCountdownEnd(timerEl) {
      const item = timerEl.closest(".m-announcement-bar__item");
      if (item) {
        this.removeItem(item);
      }
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
